import { Link } from 'react-router-dom';

const servicios = [
  { icon: 'ri-file-list-3-line', label: 'Gestión Documental', to: '/gestion-documental' },
  { icon: 'ri-search-eye-line', label: 'Auditorías HSE', to: '/auditorias' },
  { icon: 'ri-tools-line', label: 'Asesoría en Terreno', to: '/asesoria-terreno' },
  { icon: 'ri-award-line', label: 'Sistemas de Gestión', to: '/sistemas-gestion' },
  { icon: 'ri-group-line', label: 'Capacitación', to: '/capacitacion' },
];

export default function CTAServicios() {
  return (
    <section className="py-24 bg-gradient-to-br from-teal-700 via-teal-600 to-teal-800 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-white/15 border border-white/25 text-white px-5 py-2 rounded-full text-sm font-semibold mb-8">
          <i className="ri-shield-check-line"></i>
          Soluciones HSE a tu medida
        </div>

        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
          ¿Sabes exactamente qué <br />
          <span className="text-teal-200">necesita tu operación?</span>
        </h2>

        <p className="text-lg md:text-xl text-white/85 mb-10 max-w-2xl mx-auto leading-relaxed">
          Desde acreditación documental hasta auditorías en terreno — tenemos el servicio preciso para que tu empresa opere con cumplimiento y sin interrupciones.
        </p>

        {/* Service pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {servicios.map((s) => (
            <Link
              key={s.label}
              to={s.to}
              className="flex items-center gap-2 bg-white/10 border border-white/20 text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-white/25 hover:border-white/40 transition-all cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            >
              <i className={`${s.icon} text-teal-300`}></i>
              {s.label}
              <i className="ri-arrow-right-up-line text-xs text-white/60"></i>
            </Link>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/servicios"
            className="group bg-white text-teal-700 px-8 py-4 sm:px-10 rounded-lg text-base font-bold hover:bg-teal-50 transition-all inline-flex items-center gap-3 whitespace-nowrap hover:scale-105 w-[90%] sm:w-auto justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            <i className="ri-layout-grid-line text-xl"></i>
            Revisar todos los servicios
            <i className="ri-arrow-right-line text-xl transition-transform group-hover:translate-x-1"></i>
          </Link>
          <Link
            to="/contacto"
            className="border-2 border-white/40 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/10 transition-all inline-flex items-center gap-2 whitespace-nowrap focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
          >
            Solicitar asesoría
            <i className="ri-chat-1-line text-xl"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
